import { render, staticRenderFns } from "./Submit-course.vue?vue&type=template&id=2bdae3f8"
import script from "./Submit-course.vue?vue&type=script&lang=js"
export * from "./Submit-course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports